package com.kinoshazam.uiKit.components.cells.cellIcon

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.image.UiKitImage
import com.kinoshazam.uiKit.components.menuItem.UiKitHorizontalSlotsItem
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.Large
import com.kinoshazam.uiKit.theme.UiKitTheme

@Composable
fun CellIconItem(
    modifier: Modifier = Modifier,
    state: CellIconItemState,
    onClick: () -> Unit,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()

    UiKitHorizontalSlotsItem(
        modifier = modifier
            .clickable(
                interactionSource = interactionSource,
                indication = null,
                onClick = onClick,
            ),
        leadContent = {
            UiKitImage(
                modifier = Modifier
                    .size(44.dp)
                    .clip(CircleShape)
                    .border(
                        width = state.borderWidth ?: 1.5.dp,
                        color = state.borderColor ?: UiKitTheme.colors.color_1,
                        shape = CircleShape,
                    )
                    .background(
                        if (isHovered) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_4
                    )
                    .padding(4.dp),
                state = ImageUiKitState(
                    url = state.iconRes,
                    contentDescription = null,
                    placeholder = state.iconPlaceholder,
                    placeholderColor = if (isHovered) UiKitTheme.colors.color_2 else UiKitTheme.colors.color_1,
                    contentScale = ContentScale.Crop,
                ),
            )
        },
        middleContent = {
            state.title?.let {
                TextLabel(
                    modifier = Modifier.padding(start = state.gap),
                    state = TextLabelState(
                        text = state.title,
                        color = if (state.isSelected) UiKitTheme.colors.color_7 else UiKitTheme.colors.color_2,
                        textStyle = Large,
                        maxLines = 1,
                    ),
                )
            }
        }
    )
}
